import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "@/components/ui/Button";

/**
 * CTA móvil optimizado para iOS 26
 * - Mismo diseño que desktop CallToActionBanner
 * - Sin efectos de mouse para móvil
 */
const MobileCTA: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const langPrefix = `/${i18n.language}`;



  return (
    <div
      className="relative overflow-hidden py-16"
    >
      <div className="relative z-10 mx-auto max-w-7xl px-4">
        <div
          className="relative rounded-[32px] border border-gray-200 shadow-2xl overflow-hidden bg-[#00342d]"
        >
           {/* Background Pattern */}
           <div className="absolute inset-0 opacity-10" 
                style={{ backgroundImage: "radial-gradient(#00e9be 1px, transparent 1px)", backgroundSize: "20px 20px" }}>
           </div>

          <div className="p-10 md:p-12 relative z-10">
            <div className="flex flex-col items-center gap-8 text-center">
              {/* Sección de Texto */}
              <div className="flex-grow">
                <h2
                  className="text-3xl sm:text-4xl font-bold mb-4 leading-tight text-white"
                >
                  {t("ctaBanner.title", "Discover your Resonance")}
                </h2>
                <p
                  className="text-lg opacity-90 max-w-xl mx-auto text-[#ecfffb]"
                >
                  {t(
                    "ctaBanner.description",
                    "Turning the unmet needs of your customers into a win for everyone starts now"
                  )}
                </p>
              </div>

              {/* Sección del Botón */}
              <div className="w-full max-w-xs">
                <Button
                  variant="primary"
                  size="lg"
                  className="w-full shadow-lg border-none hover:scale-105 transition-transform"
                  onClick={() => navigate(`${langPrefix}/signup`)}
                  style={{
                    backgroundColor: "#00e9be",
                    color: "#00342d",
                    fontWeight: "bold",
                    padding: "1rem 2rem",
                  }}
                >
                  {t("ctaBanner.buttonText", "REQUEST A BRAINSTORM")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileCTA;
